import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const passcodeRegExp = /^\d{4}$/;

const PermissionPasscode = ({
  currentPasscode,
  wrapperClass,
  generatePermissionPasscode,
  hasPasscode,
  setPermissionPasscode,
  isPermissionCodeLoading,
}) => {
  const [passCode, setPassCode] = useState(currentPasscode);
  useEffect(() => setPassCode(currentPasscode), [currentPasscode]);

  const isSetPasscodeButtonEnabled =
      passCode &&
      passCode !== currentPasscode
      && passcodeRegExp.test(passCode)
      && !isPermissionCodeLoading;

  const onInputKeypress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();

      if (isSetPasscodeButtonEnabled) {
        setPermissionPasscode(passCode);
      }
    }
  };

  return (
    <div className={wrapperClass}>
      <div className="layout">
        <div className="layout__item u-1/1 c-label-new">Permission passcode</div>
        <div className="layout__item u-3/6" display-if={hasPasscode}>
          <input
            name="permissionPasscode"
            value={passCode || ''}
            className="c-input"
            placeholder="Enter passcode"
            onChange={e => setPassCode(e.target.value)}
            onKeyPress={onInputKeypress}
          />
        </div>
        <div
          className={classnames('layout__item', {
            'u-3/6': hasPasscode,
          })}
        >
          {hasPasscode &&
            <button
              type="button"
              className="c-btn c-btn--medium"
              disabled={!isSetPasscodeButtonEnabled}
              onClick={() => setPermissionPasscode(passCode)}
            >
              Set passcode
            </button>
          }
          {!hasPasscode &&
            <button type="button" className="c-btn c-btn--medium" onClick={generatePermissionPasscode}>
              Generate permission passcode
            </button>
          }
        </div>
      </div>
    </div>
  );
};

PermissionPasscode.propTypes = {
  currentPasscode: PropTypes.string,
  wrapperClass: PropTypes.string,
  generatePermissionPasscode: PropTypes.func.isRequired,
  hasPasscode: PropTypes.bool,
  setPermissionPasscode: PropTypes.func.isRequired,
  isPermissionCodeLoading: PropTypes.bool.isRequired,
};

PermissionPasscode.defaultProps = {
  currentPasscode: '',
  hasPasscode: false,
  wrapperClass: '',
};

export default PermissionPasscode;
